export default {
    videos: [],
    oldVideos: [],
    clips: [],
    projects: {},
    moreVideos: false,
    isLoading: true,
    isAppending: false,
    dragState: null,
    filelist: [],
    editSaved: false,
    editSaving: false,
    events: [],
    availableEvents: [],
    activeTab: "MyVideos",
    featuredVideo: {},
    isMobile: false,
    userId: null,
    urlSlug: null,
    videoPlaylist: {
        id: null,
        url: null,
        isLoaded: false,
    },
    hasUploadedVideo: false
}
